/*
 * @Author: your name
 * @Date: 2021-04-14 15:30:00
 * @LastEditTime: 2023-02-08 17:25:07
 * @LastEditors: wuchengcheng
 * @Description: In User Settings Edit
 * @FilePath: /web-platform/src/utils/form-validate.js
 */
/**
 * author: 李嘉伟
 * lastEditor: 李嘉伟
 * description: 表单常用验证方法
 * */
import DateUtils from '@/utils/date'

export const passwordRegularValid = {
  /**
   * ^ 匹配一行的开头位置
   * (?=.*[a-z]) 至少一个小写字母
   * (?=.*[A-Z]) 至少一个大写字母
   * (?=.*\d) 至少一个数字
   * [^] 其他任意字符
   * {6,14} 6到14位
   * $ 匹配行结尾位置
   */
  pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,14}$/,
  message: '密码需介于6-14个字母和数字且必须包含大小写字母和数字',
  trigger: 'blur'
}

export function mobileValidate() {
  return {
    pattern: /^[0-9]{11}$/
  }
}

export function emailValidate() {
  return {
    pattern: /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/
  }
}

export function nowDateValidate(rule, value, callback) {
  if (!value) {
    callback()
  }
  if (new Date(DateUtils.safeDate(value)) < new Date()) {
    callback(new Error('不能早于当前时间'))
  }
  callback()
}

// 开始时间校验
export function startTimeValidate(rule, value, callback) {
  if (!value) {
    callback()
  }
  if (
    new Date(DateUtils.safeDate(value)) > new Date(DateUtils.safeDate(this))
  ) {
    callback(new Error('开始时间不能晚于截止时间'))
  }
  callback()
}

/**
 * @description: 开始时间禁止选择，只能选择当天之后
 * @param {*} time: 被检验对象的值
 * @return {*}
 */
export function pickerOptionsStart(time) {
  return time.getTime() < Date.now() - 8.64e7
}

// 结束时间校验
export function endTimeValidate(rule, value, callback) {
  if (!value) {
    callback()
  }
  if (
    new Date(DateUtils.safeDate(value)) < new Date(DateUtils.safeDate(this))
  ) {
    callback(new Error('截止时间不能早于开始时间'))
  }
  callback()
}

/**
 * @description: 结束时间禁止选择，只能选择今天之后，并且要在startTime之后
 * @param {*} time 被检查对象的值
 * @param {*} startTime 被检查对象要比较的值
 * @param {*} beforeToday 被检查对象是否能选择今天之前的时间，默认可以选择今天之前
 * @return {*}
 */
export function pickerOptionsEnd(time, startTime, beforeToday = true) {
  let _startTime = ''
  if (startTime) {
    // 让用户可以选择开始结束同一天
    _startTime = new Date(DateUtils.safeDate(startTime)).valueOf() - 8.64e7 + 1
  } else if (!beforeToday) {
    _startTime = Date.now() - 8.64e7
  }
  return time && time.valueOf() < _startTime
}

// 开标时间校验
export function openTimeValidate(
  rule,
  value,
  callback,
  msg = '开标时间不能早于报名截止时间'
) {
  if (!value || !this) {
    callback()
  }
  if (
    new Date(DateUtils.safeDate(value)) < new Date(DateUtils.safeDate(this))
  ) {
    callback(new Error(msg))
  }
  callback()
}

export function requiredRule(msg, pattern = '', trigger = 'blur') {
  if (pattern) {
    return {
      required: true,
      pattern,
      message: msg,
      trigger: trigger
    }
  }
  return {
    required: true,
    message: msg,
    trigger: trigger
  }
}

/**
 * 禁止选择当天日期之前
 * @param {*} date
 * @returns
 */
export function disabledBeforeDate(date) {
  return date < new Date().setHours(0, 0, 0, 0)
}

export function disabledAfterDate(date) {
  return date > new Date().setHours(23, 59, 59, 59)
}

/**
 * 禁止选择当天时间（分钟）之前
 * @param {*} date
 * @returns
 */
export function disabledBeforeTime(date) {
  const curVal = date
  curVal.setSeconds(0, 0)

  const nowVal = new Date()
  nowVal.setSeconds(0, 0)

  return curVal.getTime() < nowVal.getTime()
}

// 发布时间校验
export function noticeReleaseTimeValidate(
  rule,
  value,
  callback,
  msg = '公告发布日期不能晚于开标时间'
) {
  if (!value || !this) {
    callback()
  }
  if (
    new Date(DateUtils.safeDate(value)) > new Date(DateUtils.safeDate(this))
  ) {
    callback(new Error(msg))
  }
  callback()
}

/**
 * 禁止选择当前分钟之前校验
 */
export function nowMinutesValidate(rule, value, callback) {
  if (!value) {
    callback()
  }
  const curVal = new Date(DateUtils.safeDate(value))
  curVal.setSeconds(0, 0)

  const nowVal = new Date()
  nowVal.setSeconds(0, 0)
  if (curVal < nowVal) {
    callback(new Error('不能早于当前时间'))
  }
  callback()
}

/**
 * 禁止选择当前日期之前
 */
export function nowDayValidate(rule, value, callback) {
  if (!value) {
    callback()
  }
  const curVal = new Date(DateUtils.safeDate(value))
  curVal.setHours(0, 0, 0, 0)

  const nowVal = new Date()
  nowVal.setHours(0, 0, 0, 0)

  if (curVal < nowVal) {
    callback(new Error('不能早于当前日期'))
  }
  callback()
}
